import React from 'react';
import LegalLayout from 'components/ui/LegalLayout';
import { usePage } from 'shared/utils/pagesStorage';

/**
 * withPageOverride — если в localStorage есть кастомный контент для slug,
 * рендерит его через LegalLayout. Иначе показывает оригинальный компонент.
 *
 * Использует useSyncExternalStore через usePage(): корректно работает с
 * конкурентным рендером и не требует useState + useEffect.
 */
const withPageOverride = (slug, DefaultComponent) => {
    const Wrapped = (props) => {
        const override = usePage(slug);

        if (override && override.bodyHtml) {
            return (
                <LegalLayout title={override.title} lastUpdated={override.lastUpdated}>
                    {/* eslint-disable-next-line react/no-danger */}
                    <div
                        className="prose prose-sm max-w-none text-text-primary"
                        dangerouslySetInnerHTML={{ __html: override.bodyHtml }}
                    />
                </LegalLayout>
            );
        }

        return <DefaultComponent {...props} />;
    };
    Wrapped.displayName = `withPageOverride(${slug})`;
    return Wrapped;
};

export default withPageOverride;
